var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['log',{logMedia:_vm.dev}],on:{"click":_vm.close}},[_c('img',{attrs:{"src":require('@/assets/img/alert.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }